import * as signalR from '@microsoft/signalr'
import { MessageBox } from 'element-ui'
const state = {
  message: [], //未读信息集合
  noReadCount: 0, //首次加载的未读信息条数
  connection: null,
  onlineCount: 0, //在线用户数量
  onlineUser: [], //在线用户信息
  noticeShowTime: 0,//index
  noticeList: [],//通知框列表,把每次打开的index放进去
  onlineHas: false
}
const mutations = {
  mSetNoticeShowTime (state, value) {
    state.noticeShowTime += 1;
    state.noticeList.push(state.noticeShowTime)
  },
  mReduceNoticeList (state, value) {
    state.noticeList.splice(state.noticeList.findIndex(item => item === value), 1)
  },
  mSetConnection (state, value) {
    state.connection = value
  },
  mSetOnline (state, value) {
    state.onlineUser = value
    state.onlineCount = value.length
  },
  mSetMsgRead (state, value) {
    state.message.splice(state.message.findIndex(item => item.id == value), 1)
    //消息读完，设置状态
    if(state.message.length==0)
    {
      state.onlineHas = false
    }
  },
  mSetNoRead (state, value) {
    state.noReadCount = value
  },
  mAddMessage (state, value) {
    state.message.unshift(value)
  },
  mChangeOnlineHas (state, value) {
    state.onlineHas = value
  },
  mClearNoReadCount (state, value) {
    state.noReadCount = 0;
  },
  mClearMessageCount (state, value) {
    state.message = [];
  },
}
const actions = {
  aInitConnection ({ commit, state, dispatch }) {
    if (state.connection === null && this.getters.UserOnline) {
      const url = `${process.env.VUE_APP_MessageUtl}/messagehub?userid=${this.getters.userInfo.UserID}&clienttype=1&clientip=''&useronline=${this.getters.UserOnline}`
      //let connection  =  new  signalR.HubConnectionBuilder().withUrl(url).withAutomaticReconnect().build();
      let connection = new signalR.HubConnectionBuilder().withUrl(url).build();
      // 连接SignalR并初始化
      connection.start().then(function () {

        // //测试心跳，频率30s
        setInterval(() => {
          connection.invoke('CheckHealth').catch(err => {

          });
        }, 60000);
        //查看在线人数，频率1min
        // setInterval(() => {
        //     connection.invoke('OnlineUser').catch(err => {   

        //     });
        // }, 5000);
      }).catch(err => {

      });

      //在线用户
      connection.on("OnlineUser", res => {
        // console.log(res)
        commit('mSetOnline', res)
      });

      //接受消息
      connection.on("ReceiveMessage", res => {
        //console.log(res)
        commit('mAddMessage', res)
        commit('mChangeOnlineHas', true)

        //回执消息，通知后台信息已接受
        connection.invoke('ClientRequire', res.id).catch(err => {

        });
      });

      // 接收服务器消息
      connection.on("OperateMessage", function (res) {
        // console.log(res)
        if (res.state === 1) {
          /// 类型 1.登录 2.系统回执 3.强制下线 4.心跳检测 5.未读消息 6.用户退出 7.断开连接
          switch (res.type) {
            case 1:
              break;
            case 2:
              break;
            case 3: //强制下线
              commit('mSetNoRead', [])
              connection.stop();
              connection.onclose(err => { })
              commit('mSetConnection', null);
              //清除token
              dispatch('user/resetToken', {}, { root: true });
              MessageBox.alert('您已被强制下线,请重新登录！', '警告', {
                showClose: false,
                closeOnClickModal: false,
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.push({
                    path: "/login",
                  });
                }
              });
              break;
            case 4:
              break;
            case 5: //未读消息条数
              commit('mSetNoRead', res.message)
              break;
            case 6:
              connection.stop();
              commit('mClearMessageCount')
              commit('mSetConnection', null);
              break;
            case 7:
              connection.stop(); 
              //清除token
              // dispatch('user/resetToken', {}, { root: true });
              MessageBox.alert('消息链接已断开，不可使用消息功能，其他功能可正常使用', '警告', {
                showClose: false,
                closeOnClickModal: false,
                confirmButtonText: '确定',
                callback: action => {
                }
              });
              break;
          }
        }

      });

      commit('mSetConnection', connection)
    }
  },
  aLoginOut ({ commit, state }) {
    if (state.connection) {
      commit('mSetNoRead', [])
      state.connection.invoke('LoginOut').catch(err => { });
    }

  }

}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/message.js